import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import lazyLoadView from '@/util/lazyLoadView';
import { userHasRole } from '@/util/RoleUtils';

import SideNavSectionView from '../../../common/views/SideNavSectionView';
import commandHeaderView from '../../views/commandHeaderView/commandHeaderView';
import LoadCommandDetailsForm from '../../loaders/CommandDetailsFormLoader';
import LoadCommandAssessments from '../../loaders/CommandAssessmentsLoader';
import LoadCommandOrders from '../../loaders/CommandOrdersLoader';
import LoadCommandInventory from '../../loaders/CommandInventoryLoader';
import CommandCustomersLoader from '../../loaders/CommandCustomersLoader';

import tmplcommandPage from './commandPage.hbs';
import './commandPage.css';

const commandPage = View.extend({
  template: tmplcommandPage,

  className: 'command-page container-fluid',

  ui: {
    sections: '.sections-container',
    commandHeader: '.command-header'
  },

  regions: {
    sections: '@ui.sections',
    commandHeader: '@ui.commandHeader'
  },

  onRender() {
    const commandIdentifiers = this.model.get('commandIdentifiers');
    const commandId = commandIdentifiers.id;
    const sideNavCollection = new Backbone.Collection([
      {
        id: 'commandDetails',
        title: 'Details',
        loader: LoadCommandDetailsForm,
        isSavable: false,
        loaderOptions: {
          commandId
        },
        view: lazyLoadView(() => LoadCommandDetailsForm(commandId))
      },
      {
        id: 'commandOrders',
        title: 'Orders',
        isSavable: false,
        loader: LoadCommandOrders,
        loaderOptions: {
          commandId
        },
        view: lazyLoadView(() => LoadCommandOrders(commandId))
      },
      {
        id: 'commandAssessments',
        title: 'Assessments',
        isSavable: false,
        loader: LoadCommandAssessments,
        loaderOptions: {
          commandId
        },
        view: lazyLoadView(() => LoadCommandAssessments(commandId))
      },
      {
        id: 'commandInventory',
        title: 'Command Inventory',
        loader: LoadCommandInventory,
        isSavable: false,
        loaderOptions: {
          commandId
        },
        view: lazyLoadView(() => LoadCommandInventory(commandId))
      }
    ]);

    if (userHasRole('CRS') || userHasRole('Admin')) {
      sideNavCollection.add({
        id: 'commandCustomers',
        title: 'Customers',
        isSavable: false,
        loader: CommandCustomersLoader,
        loaderOptions: {
          commandId
        },
        view: lazyLoadView(() => CommandCustomersLoader(commandId))
      });
    }
    this.showChildView(
      'sections',
      new SideNavSectionView({
        model: new Backbone.Model({
          commandId,
          returnLabel: 'Return to Dashboard',
          returnLink: '#dashboard'
        }),
        collection: sideNavCollection,
        editable: true,
        useNavigationButtons: true
      })
    ),
      this.showChildView(
        'commandHeader',
        new commandHeaderView({
          model: new Backbone.Model({
            ...commandIdentifiers
          })
        })
      );
  }
});

export default commandPage;
